// src/components/molecules/add-to-cart/index.js

export { default } from './AddToCart.tsx';
